import {
  useEmployeeIsNursingHomeAdminOrManager,
  useIsNursingHomeScope,
} from '@pflegenavi/frontend/nursing-home-context';

import { useEmployeeProfilePhoenix } from '@pflegenavi/frontend/api-nursing-home';

export function useCanSeeEmployeeList(): boolean {
  const { data: employeeProfile } = useEmployeeProfilePhoenix({});

  const isNursingHomeAdminOrManager = useEmployeeIsNursingHomeAdminOrManager();
  // Above nursing home scope the scope selector has already required the admin
  // or manager role, see RouteAccessGuard.
  const isNursingHomeScope = useIsNursingHomeScope();

  // The employee list requires the new authorization system (roles), so we gate
  // it on `use_new_authorization` instead of the former EmployeeManagement
  // feature flag — hidden on legacy-authorization tenants.
  return (
    Boolean(employeeProfile?.use_new_authorization) &&
    (isNursingHomeAdminOrManager || !isNursingHomeScope)
  );
}
